export const photos = [
    'https://res.cloudinary.com/dmdcrs852/image/upload/v1553197608/ComeBackToMe/cbtm.jpg',
    'https://res.cloudinary.com/dmdcrs852/image/upload/v1553197623/ComeBackToMe/come003.jpg',
    'https://res.cloudinary.com/dmdcrs852/image/upload/v1553197642/ComeBackToMe/come004.jpg',
    'https://res.cloudinary.com/dmdcrs852/image/upload/v1553197645/ComeBackToMe/come005.jpg',
    'https://res.cloudinary.com/dmdcrs852/image/upload/v1553197646/ComeBackToMe/come007.jpg',
    'https://res.cloudinary.com/dmdcrs852/image/upload/v1553197646/ComeBackToMe/come008.jpg'
];